import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/media-has-caption */
import cn from 'classnames';
import { memo, useCallback, useRef, useState } from 'react';
import { File } from '@/components/Icons/File';
import { LoadingIcon } from '@/components/Icons/LoadingIcon';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { useController } from '@/hooks/useController';
import { LightBox } from '@/newComponents/LightBox';
import styles from './ChatEvent.module.scss';
export const RenderType = memo(({ type, url, title, isDownloading, handleImageLoad }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const { notifyWebviewOpened, notifyWebviewClosed } = useController();
    const handleImageOpen = useCallback(() => {
        notifyWebviewOpened();
        setOpen(true);
    }, [notifyWebviewOpened]);
    const handleImageClose = useCallback(() => {
        notifyWebviewClosed();
        setOpen(false);
    }, [notifyWebviewClosed]);
    switch (type) {
        case 'image':
            return (_jsxs(_Fragment, { children: [isDownloading && (_jsx("div", { className: styles.placeholder, children: _jsx(LoadingIcon, { variant: "light" }) })), _jsx(Dialog, { open: open, children: _jsx(DialogContent, { onInteractOutside: (e) => e.preventDefault(), onEscapeKeyDown: (e) => e.preventDefault(), className: cn('h-full w-full bg-black p-0'), children: _jsx(LightBox, { onClose: handleImageClose, url: url }) }) }), _jsx("button", { onClick: handleImageOpen, className: "block cursor-pointer border-0 bg-transparent p-0 shadow-[var(--moveo-shadow-bubble)]", children: _jsx("img", { src: url, alt: title || '', className: cn('block max-h-[400px] w-full max-w-full rounded-[var(--moveo-border-radius-base)]', {
                                hidden: isDownloading,
                            }), onLoad: handleImageLoad, onError: handleImageLoad, ref: ref }) })] }));
        case 'video':
            return _jsx("video", { src: url, controls: true });
        case 'audio':
            return _jsx("audio", { src: url, controls: true });
        case 'file':
            return (_jsxs("a", { href: url, download: title, target: "_blank", rel: "noreferrer", className: "flex items-center gap-1 text-sm [&_svg]:flex-shrink-0", children: [_jsx(File, { color: "var(--moveo-accent-color)", size: 16 }), '\u00A0', title] }));
        default:
            return (_jsxs("a", { href: url, download: title, target: "_blank", className: styles.link, rel: "noreferrer", children: [_jsx(File, { color: "var(--moveo-accent-color)", size: 16 }), '\u00A0', title] }));
    }
});
RenderType.displayName = 'RenderType';
